module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "agc-images-container"
  }, _vm._l((_vm.agc), function(elem) {
    return _c('div', {
      staticClass: "agc-images-thumbnail"
    }, [_c('div', {
      staticClass: "agc-category-name-layer"
    }, [_c('router-link', {
      attrs: {
        "to": ("/agc/" + (elem._id))
      },
      domProps: {
        "innerHTML": _vm._s(elem.title[_vm.locale])
      }
    })], 1), _vm._v(" "), _c('img', {
      attrs: {
        "src": ("static/images/agc/thumbnails/" + (elem.thumbnail))
      }
    })])
  }), 0), _vm._v(" "), _c('h2', {
    staticClass: "w3-xxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('Referenciák')))])]), _vm._v(" "), _c('agc-gallery')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v("AGC")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-396bfa00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agc.vue
// module id = 939
// module chunks = 0